/**
 * Konkord: the role our bot gives to whoever uses our app (it keeps the calls
 * of these servers out of Stoat's own app, where they'd be a separate call).
 * It says nothing about the person, so profiles don't list it; server settings
 * still do. Same list as KONKORD_MEMBER_ROLES on the voice server.
 */
const MEMBER_ROLES = new Set([
  "01M5Z6Y8499EZHEPXCHTT0CXJ1", // Estrela
  "01M6GRRCE7NECZ5XN5P2XS9G22", // Konkordh
]);

export function isHiddenRole(id: string) {
  return MEMBER_ROLES.has(id);
}
